/* global OCmodel */
import { isAndroid, isiOS } from "helper/env";
import { setAuth } from "helper/configAuth";
import dev from "helper/dev";
import fectx from "helper/fectx";
import statistic from "./statistic";
import "./common";

let initResolve;
const initPromise = new Promise(resolve => {
  initResolve = resolve;
});
let token = null;
let loginCb = null;
let shareCb = null;
let shareData = {};

if (process.env.NODE_ENV === "development") {
  const Nothing = (() => {
    const fn = () => Nothing;
    fn.toString = fn.toLocaleString = fn[Symbol.toPrimitive] = () => "";
    fn.valueOf = () => false;

    return new Proxy(fn, {
      get: (o, key) => (o.hasOwnProperty(key) ? o[key] : Nothing)
    });
  })();
  window.OCmodel = Nothing;
}

function setToken(value) {
  token = value;
  setAuth("ustr", token);
}

function clearToken() {
  token = null;
}

export function getToken() {
  return token;
}

export function getUrlKey(key){
  return decodeURIComponent((new RegExp('[?|&]' + key + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [, ""])[1].replace(/\+/g, '%20')) || ""
}

export function init() {
  console.log("in App");

  fectx.interceptors.response.use(response => {
    if (
      // eslint-disable-next-line eqeqeq
      response.status == "403" &&
      response.data &&
      response.data.InnerData === "用户信息无效"
    ) {
      logout();
      login();
    }

    return response;
  });

  if (isAndroid) {
    console.log("Android inject:", window.OCmodel);
    window.OCmodel.getAppInfo(); //调用原生方法
  } else if (isiOS) {
    console.log("iOS inject:", typeof OCmodel, OCmodel);
    OCmodel.getAppInfo(); //调用原生方法
  }

  return initPromise.then(() => {
    // hooks: after init
    // 在此发送统计确保拿到用户标识符
    statistic(2);
  });
}

export function bindPhone() {
  console.log("call service.bindPhone");
  // do nothing
}

export function isLogin() {
  const token = getToken();
  return token !== undefined && token !== null && token !== "";
}

export function login(cb) {
  // mock(
  //   'ESWkaLG3T8joYlR5OhUjHO9bScUDjuvY9WsOnTrhV2J%2fs9o0t%2fLOOZX9a6Iarv5PW5mDldPdQdU%3d'
  // );
  // cb();

  loginCb = cb;
  if (isAndroid) {
    window.OCmodel.showLoginPopup(); //调用原生方法：登录
  } else if (isiOS) {
    OCmodel.showLoginPopup(); //调用原生方法：登录
  }
}

//设置原生app的头名称
export function setTitle(title) {
  if (isAndroid) {
    window.OCmodel.setInnerTitle(title); //调用原生方法：设置app的头名称
  } else if (isiOS) {
    OCmodel.setInnerTitle(title); //调用原生方法：设置app的头名称
  }
}

export function setShareData({
  title,
  description,
  imageUrl,
  url,
  onSuccess
} = {}) {
  shareData = {
    title: title ? title : document.title,
    description: description,
    imageUrl: imageUrl,
    url: url
  };

  if (onSuccess) {
    shareCb = onSuccess;
  }
}

//调用原生app的分享
export function shareUrl() {
  console.log(`share url: ${shareData.url}`);

  statistic(1);
  if (isAndroid) {
    window.OCmodel.goShareUrl(JSON.stringify(shareData)); //调用原生方法：分享
  } else if (isiOS) {
    OCmodel.goShareUrl(shareData); //调用原生方法：分享
  }
}

export function logout() {
  clearToken();
}

export function gotoUrl(url) {
  if (process.env.NODE_ENV === "development") {
    console.log("goto", url);
  } else {
    window.location.href = url;
  }
}

export function mock(si) {
  initResolve();
  setToken(si);
}

export async function choosePay(paydata, { method = "wechat" } = {}) {
  if (method === "alipay") {
    return callApp("AliPay", paydata);
  }

  if (method === "wechat") {
    if (isAndroid) {
      paydata = JSON.stringify(paydata);
    }
    return callApp("WeChatPay", paydata);
  }

  return Promise.resolve(false);
}

// //原生app内跳转链接
// export function goPage(url) {
//   if (isAndroid) {
//     window.OCmodel.goPage(url); //调用原生方法：原生跳转链接
//   } else if (isiOS) {
//     OCmodel.goPage(url); //调用原生方法：原生跳转链接
//   }
// }

// //原生app内跳转到商品详情页
// export function goItem(itemInfoId) {
//   if (isAndroid) {
//     window.OCmodel.goItem(itemInfoId); //调用原生方法：跳转到原生商品详情页
//   } else if (isiOS) {
//     OCmodel.goItem(itemInfoId); //调用原生方法：跳转到原生商品详情页
//   }
// }
export function iosLess620() {
  if(isiOS){
    try {
      window.OCmodel.isEnableAppNotice();
      return false
    } catch (e) {
      return true
    }
  }else {
    return false
  }
}
const callMap = Object.create(null);
export async function callApp(method, ...args) {
  const app = window.OCmodel;
  if (!app || !app[method]) {
    if (iosLess620()){
      alert('该活动需更新至最新版APP才能参与，请升级APP版本')
    }
    throw new Error("该活动需更新至最新版APP才能参与，请升级APP版本");
  }

  return new Promise((resolve, reject) => {
    onAppCallback(method, resolve, reject);

    console.log(`before callApp ${method}`, ...args);
    app[method](...args);
    console.log(`did callApp ${method}`, ...args);

    dev(() => {
      setTimeout(() => {
        switch (method) {
          case "getUserInfo":
            window.userInfoCallback(
              JSON.stringify({
                SessionId:
                  "N5koH0GAwM2GNSuOBP52xVUgGfdlMyOOjPFDAksZVtYaNyI463oAOBdu%2b0Qzm2NbLLZETQJBIY8%3d",
                CustomerLevelName: "新新会员",
                OrderWaitPackingNum: "16",
                OrderWaitPayNum: "0",
                ExperienceCount: "0",
                CustomerName: "不要艾特我abcd",
                RegionId: "16890",
                GiftCount: "5",
                CustomerLevelId: "65",
                OrderWaitShippedNum: "0",
                OrderWaitCommentNum: "2",
                Integral: "300400",
                CustomerId: "4137441",
                ScoreText: "积分",
                CouponCount: "4",
                CustomerIcon: "http://i.lifevccdn.com/",
                Token:
                  "NDEzNzQ0MTpNemN0T1RrdE1qZ3RNVVl0TkRFdE9EQXRRekF0UTBRdE9EWXRNelV0TWtJdE9FVXRNRFF0UmtVdE56WXRRelV0UlRrdE5VVXRPVVF0TmpjdE56UXRNalF0UmpVdE16a3ROemN0UkRJdE56UXRSVEV0UlRZdFFVTXRNMFl0UVRrdFJrVXROekF0TWpNdFJqZ3ROakl0TmtJdE5qTXROekF0TkRrdE9FSXROa0l0TTBZdFFUa3RNekF0TkVRdFJEY3RPRUV0UWpjdFF6Z3ROekF0UlRZdFEwTXRNRGd0T0RNdFFqUXRRVFV0T1RJdE5VWXRPRVF0UkRFdE1qVXRNRUk9"
              })
            );
            break;
          case "AliPay":
          case "WeChatPay":
            window.PayCallBack("true");
            break;
          default:
            break;
        }
      }, 1500);
    });
  });
}

async function onAppCallback(method, suc, fail = () => null) {
  callMap[method] = [suc, fail];
}

function getAppCallback(key) {
  const v = callMap[key];
  if (v) {
    delete callMap[key];
  }

  return v;
}

export function toBoolean(value) {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true' || value === '1'
  }

  return value
}

//原生app打开本页连接后回调的js方法
window.initializeAsyn = si => {
  initResolve();

  console.log("app call initializeAsyn with si:", si);
  if (si) {
    let token;
    if (isAndroid) {
      token = encodeURIComponent(si);
    } else {
      token = si;
    }
    console.log("normalized si:", token);
    setToken(token);
  }

  if (loginCb) {
    console.log("exec login callback:", si);
    loginCb();
  }
};

//原生app分享到微信后，用户从微信转回app时原生回调的js方法
window.shareResult = status => {
  console.log("app share result", status);
  // eslint-disable-next-line eqeqeq
  if (status == 1) {
    if (shareCb) {
      shareCb();
    }
  }
};

// app 回调, 添加商品是否成功
window.addCartCallback = isSuccess => {
  console.log("app addCartCallback", isSuccess);
  if (!callMap["addCart"]) return;

  const [cb, _] = callMap["addCart"];
  if (cb) {
    cb(toBoolean(isSuccess));
  }
};

// app 回调, 添加礼品券是否成功
window.addGiftCouponCallback = isSuccess => {
  console.log("app addGiftCouponCallback", isSuccess);
  if (!callMap["addGiftCoupon"]) return;

  const [cb, _] = callMap["addGiftCoupon"];
  if (cb) {
    cb(toBoolean(isSuccess));
  }
};

window.userInfoCallback = jsonStr => {
  console.log("app userInfoCallback", jsonStr);
  if (!callMap["getUserInfo"]) return;

  const [resolve, reject] = callMap["getUserInfo"];
  try {
    resolve(JSON.parse(jsonStr));
  } catch (error) {
    reject(new Error("获取用户信息失败"));
  }
};

window.cartNumCallback = num => {
  console.log("app cartNumCallback", num);
  if (!callMap["getCartNum"]) return;

  const [resolve, _] = callMap["getCartNum"];
  resolve(+num);
};

window.PayCallBack = status => {
  const cbs = getAppCallback("AliPay") || getAppCallback("WeChatPay");
  if (!cbs) return;

  const [resolve, _] = cbs;
  resolve(toBoolean(status));
};
